import { action } from 'satcheljs';

export default action('HIDE_QUICK_OPTIONS', () => ({}));
